import { units } from '@ui/css';
import { combineTokens } from '@utils/css';

const transitionDurationMs = 425;
const sheetTokens = combineTokens("--sheet", {
  zoom: 1,
  insetBlock: units.px(180),
  insetInline: units.px(250)
});
const section = "_086sp6bbc7";
const transition = "_086t1x22glb";
const contentWrapper = "_086c1n8nize";
const wrapper = "_086w11gy2xa";
const navButtonTrack = "_086nc4lv7l";
const navButton = "_086ndmoow2";
const fullscreenButton = "_086f1aranf7";

export { contentWrapper, fullscreenButton, navButton, navButtonTrack, section, sheetTokens, transition, transitionDurationMs, wrapper };
import "./_content.style.linaria.module.css";
//# sourceMappingURL=_content.style.js.map
